// 全网汇聚
import { createAPI } from '@common'
export default {
  // 获取省市
  regions: (config) =>
    createAPI('customEncryptApiName-1/0bqj0sfhjpot', 'post', config, {
      hubForward: true,
      hub: '/v1/repository/hub'
    }),
  // 信源
  media: (config) =>
    createAPI('customEncryptApiName-1/0bqj0ebubuzqf0nfejb', 'post', config, {
      hubForward: true,
      hub: '/v1/repository/hub'
    }),
  // 信源等级
  levels: (config) =>
    createAPI('customEncryptApiName-1/0bqj0tpvsdf0mfwfmt', 'post', config, {
      hubForward: true,
      hub: '/v1/repository/hub'
    }),
  // 频道分类
  categories: (config) =>
    createAPI('customEncryptApiName-1/0bqj0tpvsdf0diboofm0dbufhpsjft', 'post', config, {
      hubForward: true,
      hub: '/v1/repository/hub'
    }),
  // 列表
  getList: (config) =>
    createAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb', 'post', config, {
      hubForward: true,
      hub: '/v1/repository/hub'
    }),
  // 详情
  postFtsDocument: (config) =>
    createAPI('customEncryptApiName-1/0bqj0gut0epdvnfou', 'post', config, {
      hubForward: true,
      hub: '/v1/repository/hub'
    })
}
